export default {"src":"/_next/static/media/Mosel.827bec28.svg","height":160,"width":259,"blurWidth":0,"blurHeight":0};